<a class="radio-btn" *ngFor="let option of options" (click)="select(option)">
  <t-icon name="radio_button_checked" *ngIf="option.value === selectedValue"></t-icon>
  <t-icon name="radio_button_unchecked" *ngIf="option.value !== selectedValue"></t-icon>
  <span>{{ option.text }}</span>
</a>